<div class="main-container" appFlyoutAnchor>
  <section class="banner"></section>
  <div class="app-container">
    <aside
      nav-menu
      class="sidebar"
      [items]="navItems()"
      [logoText]="applicationName"
      [logoIcon]="applicationIcon"
    ></aside>
    <main class="main-content" id="main-content">
      <header class="top-header">
        <nav class="breadcrumb">
          <span class="current-page">{{ title }}</span>
        </nav>

        <div class="topbar-center">
          <nav class="tab-nav" role="tablist">
            <ng-container
              *ngTemplateOutlet="bridge.portalContent()"
            ></ng-container>
          </nav>
        </div>

        <div class="header-actions">
          <button class="icon-button" aria-label="Notification">
            <span class="material-icons notification-bell" aria-hidden="true"
              >notifications</span
            >
            <span class="notification-badge" aria-hidden="true"></span>
          </button>
          <app-user-dropdown></app-user-dropdown>
        </div>
      </header>
      <div tpToolbar id="ribbon"></div>
      <div class="content-area" [class]="layoutClass()">
        <router-outlet></router-outlet>
      </div>
      <div tpToolbar id="tray" class="tray"></div>
    </main>
  </div>
</div>
